import { deleteWithToken } from 'api/network';
import { put, takeEvery, select } from 'redux-saga/effects';
import {
  appNotify,
  deleteAssumptionModule,
  fetchAssumptionModules,
  setModulesAreLoading,
  setSelectedModule,
  setSelectedModuleId,
} from '../../../store/actions';
import { selectedModuleSelector } from '../../../store/selectors';

export function* deleteAssumptionModuleSaga() {
  yield takeEvery(deleteAssumptionModule, function* ({ payload }) {
    try {
      yield put(setModulesAreLoading(true));

      const url = `/api/assumptions/modules/${payload}`;
      yield deleteWithToken(url, payload);

      const selectedModule = yield select(selectedModuleSelector);

      if (selectedModule?.id === payload) {
        yield put(setSelectedModule(null));
        yield put(setSelectedModuleId(null));
      }

      yield put(setModulesAreLoading(false));
      yield put(fetchAssumptionModules());
      yield put(appNotify('Module deleted', 'success'));
    } catch (error) {
      yield put(
        appNotify(`Failed to delete assumption module: ${error.message}`, 'error')
      );
      yield put(setModulesAreLoading(false));
    }
  });
}
